export default __webpack_public_path__ + "static/media/wordle.d6ad9a78.jpeg";